import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const ChevronLeft = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);

export default function PostRide() {
  const navigate = useNavigate();
  const { currentUser, postRide } = useApp();

  const today = new Date().toISOString().split('T')[0];

  const [form, setForm] = useState({
    departure: '',
    destination: '',
    date: today,
    time: '08:00',
    seats: 2,
    price: 10,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  if (!currentUser.isDriver) {
    return (
      <div className="page" style={{ textAlign: 'center', paddingTop: 80 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🚗</div>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 10 }}>Become a Driver</h2>
        <p style={{ color: 'var(--gray-400)', fontSize: 14, marginBottom: 24, lineHeight: 1.6 }}>
          To post rides, you need to add your car details first.
        </p>
        <button className="btn btn-primary" onClick={() => navigate('/edit-profile')}>
          Set Up Driver Profile
        </button>
      </div>
    );
  }

  const handleSubmit = () => {
    if (!form.departure.trim()) { setError('Departure location is required.'); return; }
    if (!form.destination.trim()) { setError('Destination is required.'); return; }
    if (!form.date) { setError('Date is required.'); return; }
    if (form.date < today) { setError('Date cannot be in the past.'); return; }
    if (form.seats < 1 || form.seats > 6) { setError('Seats must be between 1 and 6.'); return; }
    if (form.price < 0) { setError('Price cannot be negative.'); return; }
    setError('');
    setLoading(true);
    const result = postRide({
      departure: form.departure,
      destination: form.destination,
      date: form.date,
      time: form.time,
      seats: Number(form.seats),
      price: Number(form.price),
    });
    setLoading(false);
    if (result.error) { setError(result.error); return; }
    navigate(`/ride/${result.rideId}`);
  };

  return (
    <div className="page">
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 28, paddingTop: 8 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', padding: 4, color: 'var(--gray-300)', marginRight: 12 }}>
          <ChevronLeft />
        </button>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800 }}>Post a Ride</h1>
          <p style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 2 }}>Offer seats to fellow students</p>
        </div>
      </div>

      {/* Car reminder */}
      {currentUser.car && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10,
          background: 'var(--accent-light)', border: '1px solid rgba(59,130,246,0.3)',
          borderRadius: 'var(--radius-sm)', padding: '10px 14px', marginBottom: 20,
        }}>
          <span style={{ fontSize: 18 }}>🚗</span>
          <span style={{ fontSize: 13, color: 'var(--accent)' }}>
            {currentUser.car.color} {currentUser.car.make} {currentUser.car.model}
          </span>
        </div>
      )}

      {error && <div className="alert alert-error">{error}</div>}

      <div className="form-group">
        <label className="form-label">Departure Location</label>
        <input className="form-input" type="text"
          placeholder="e.g. MIT Campus, Cambridge MA"
          value={form.departure} onChange={e => set('departure', e.target.value)} />
      </div>

      <div className="form-group">
        <label className="form-label">Destination</label>
        <input className="form-input" type="text"
          placeholder="e.g. South Station, Boston MA"
          value={form.destination} onChange={e => set('destination', e.target.value)} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div className="form-group">
          <label className="form-label">Date</label>
          <input className="form-input" type="date" min={today}
            value={form.date} onChange={e => set('date', e.target.value)}
            style={{ colorScheme: 'dark' }} />
        </div>
        <div className="form-group">
          <label className="form-label">Time</label>
          <input className="form-input" type="time"
            value={form.time} onChange={e => set('time', e.target.value)}
            style={{ colorScheme: 'dark' }} />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div className="form-group">
          <label className="form-label">Available Seats</label>
          <input className="form-input" type="number" min="1" max="6"
            value={form.seats} onChange={e => set('seats', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Price per Person ($)</label>
          <input className="form-input" type="number" min="0" step="0.5"
            value={form.price} onChange={e => set('price', e.target.value)} />
        </div>
      </div>

      <div style={{
        background: 'var(--navy-mid)', border: '1px solid var(--navy-border)',
        borderRadius: 'var(--radius-sm)', padding: '14px 16px', marginBottom: 24,
      }}>
        <p style={{ fontSize: 12, color: 'var(--gray-400)', lineHeight: 1.6 }}>
          💡 <strong style={{ color: 'var(--gray-300)' }}>Tip:</strong> Set a fair price to cover your gas.
          Students appreciate transparency. You can always message riders after they're accepted.
        </p>
      </div>

      <button className="btn btn-primary btn-full" onClick={handleSubmit} disabled={loading}
        style={{ padding: '14px', fontSize: 15 }}>
        {loading ? 'Posting...' : 'Post Ride'}
      </button>
    </div>
  );
}
